const breakpoints = [768];

const mq = breakpoints.map((bp) => `(min-width: ${bp}px)`);

export default mq;
